import React from 'react';
import Spinner from '../spinner';

export default function LoadingOverlay(props) {
  return (
    <div
      className="tw:absolute tw:inset-0 tw:z-5 tw:bg-white/60"
      style={{ zIndex: props.zIndex ? props.zIndex : null }}
    >
      <div className="tw:absolute tw:inset-x-0 tw:top-0 tw:flex tw:h-full tw:max-h-150 tw:items-center tw:justify-center">
        <Spinner className="tw:size-8 tw:text-muted-foreground" />
      </div>
    </div>
  );
}
